import Action from './Action'

export default class ActionCollection extends Set {
  add(action) {
    // eslint-disable-next-line no-unsafe-negation
    if (!action instanceof Action) {
      throw Error('Invalid [Action] argument type. ')
    }

    super.add(action)
  }
}
